import {
  judgeUpdatePortSetup,
  updateComponentsPackage,
  updateComponentsPortSetup,
  judgePortGenerateSetupUpdate,
  updatePortGenerateSetupByComps,
  judgeUpdateGapPortSetup,
  updateExtractionGapPortsSetup,
  getUsableComps,
  getExtractionType,
  setDefaultModelKeyInConnPkgModel,
  updateModelInfoInConnPkgModel,
  updateExtractionInfo,
  judgeSelectCompExist,
  setSelectCompInComponents
} from ".";
import { isPreLayout } from "..";
import { ANDES_V2 } from "../../../constants/pageType";
import { updateSetupComponentsByPortType } from "../../ExtractionPortsHelper";
import { versionCompareSize } from "../../helper/dataProcess";
import designConstructor from "../../helper/designConstructor";
import { CPHY, GENERIC, HDMI, PCIE } from "../../PCBHelper/constants";
import {
  judgeAMIFlagExist,
  judgeJittersUnitUpdate,
  updateAdsJittersUnit,
  updateSignalAMIFlags
} from "../AMIModelHelper";
import {
  getSeaSimChannels,
  judgeSeasimConfigEQValue,
  judgeSeasimConfigGeneralValue,
  SeaSimConfig,
  updateAdsConfigDFEValue,
  updateSeasimConfigEQ,
  updateSeasimConfigInfo,
  updateSeasimEQConfig,
  judgeSeaSimConfigUpdate
} from "../seaSim";
import { checkCtleModelPairs } from "../simulation";
import { setDefaultAMIModel } from "./AMIModelHelper";
import { insertAdditionalNetsOption, updateModelInfoInComponent } from "./channelContentHelper";
import { HFSSInfo } from "./IntegratedChannel";

/**
 * 
 * @param {Object} channelInfo 
 * @param {Object} _pcbInfo  
 * @returns 
 */
function checkVersionUpdate(_channelInfo, _pcbInfo) {
  let channelInfo = { ..._channelInfo };
  let save = false, findRefNetsStatus = false, updateGeneratePortsErrorsParams = null;
  const isPreLayoutChannel = isPreLayout(channelInfo.designId)
  //find reference nets
  if (versionCompareSize(channelInfo.version, "0.0.2") && !isPreLayoutChannel) {
    findRefNetsStatus = true;
  }

  //Compatible with the old version,( not exist selectedSignals )
  if (channelInfo.content && !channelInfo.content.selectedSignals) {
    channelInfo.content.selectedSignals = channelInfo.content.signals ?
      channelInfo.content.signals.map(item => item.name) : [];
    save = true;
  }

  //component set default package model
  if (versionCompareSize(channelInfo.version, "0.0.4")) {
    channelInfo = updateComponentsPackage(channelInfo);
    save = true;
  }

  const design = designConstructor.getDesign(channelInfo.designId);
  const isReplace = design && design.designVersion !== channelInfo.designVersion;
  if (isReplace) {
    return { channelInfo, isReplace, save, findRefNetsStatus };
  }

  //port setup not exist
  if (!isPreLayoutChannel && (versionCompareSize(channelInfo.version, "0.0.3") || judgeUpdatePortSetup(channelInfo))) {
    const info = updateComponentsPortSetup(channelInfo, _pcbInfo);
    channelInfo = info.channelInfo;
    updateGeneratePortsErrorsParams = { id: channelInfo.id, errors: info.errors, warnings: info.warnings };
    save = true;
  }

  //update port generate setup by components, "ports_generation_setup" to "ports_generate_setup_list"
  if (!isPreLayoutChannel && (versionCompareSize(channelInfo.version, "0.0.6") || judgePortGenerateSetupUpdate(channelInfo))) {
    channelInfo = updatePortGenerateSetupByComps(channelInfo);
    save = true;
  }

  //when extraction type HFSS to SIwave, and port type is GAP,and reference type is nearby pins or single pin pre reference nets
  //re generate port setups by port type is GAP, reference type is All pins
  if (!isPreLayoutChannel && judgeUpdateGapPortSetup(channelInfo)) {
    const resInfo = updateExtractionGapPortsSetup(channelInfo);
    channelInfo = resInfo.channelInfo;
    updateGeneratePortsErrorsParams = { id: channelInfo.id, errors: resInfo.errors, warnings: resInfo.warnings };
    save = true;
  }

  //init pcie seaSim config
  if (channelInfo.type === PCIE && (versionCompareSize(channelInfo.version, "0.0.7") || judgeSeaSimConfigUpdate(channelInfo))) {
    const { channels, analysisChannels } = getSeaSimChannels({
      signals: channelInfo.content.signals,
      components: getUsableComps(channelInfo),
      netsList: _pcbInfo.netsList,
      layers: _pcbInfo.layers,
      selectedSignals: channelInfo.content.selectedSignals,
      isPreLayoutChannel
    });
    channelInfo.config = new SeaSimConfig({ channels, analysisChannels });
    save = true;
  }

  //update port generate setup for components setup, gap_size,ball_size,ball_height
  if (!isPreLayoutChannel && (versionCompareSize(channelInfo.version, "0.0.9") && channelInfo.content && channelInfo.content.components)) {
    channelInfo.content.components = updateSetupComponentsByPortType({
      components: channelInfo.content.components,
      designId: channelInfo.designId,
      ports_generate_setup_list: channelInfo.content.ports_generate_setup_list,
      extractionType: getExtractionType(channelInfo.content.extraction),
      isUsedBall: true,
      product: ANDES_V2
    });
    save = true;
  }

  //add backdrillVias ,backdrillStubSize to extraction
  if (!isPreLayoutChannel && versionCompareSize(channelInfo.version, "0.0.11") && channelInfo.content && channelInfo.content.extraction) {
    channelInfo.content.extraction = { ...channelInfo.content.extraction, backdrillVias: true, backdrillStubSize: "8mil" }
    save = true;
  }

  //Re-use the same sub-model for other signals (connector and package)
  if (versionCompareSize(channelInfo.version, "0.0.12") && channelInfo.content) {
    channelInfo = setDefaultModelKeyInConnPkgModel(channelInfo);
    save = true;
  }

  //set default ami model
  if ([PCIE, HDMI, GENERIC, CPHY].includes(channelInfo.type) && channelInfo.content && (versionCompareSize(channelInfo.version, "0.0.14") || !Object.keys(channelInfo.adsConfig || {}).length)) {
    channelInfo = setDefaultAMIModel(channelInfo, { isPreLayoutChannel, netsList: _pcbInfo.netsList, serdesType: channelInfo.type });
    save = true;
  }

  if ([PCIE, HDMI, GENERIC].includes(channelInfo.type) && channelInfo.adsConfig && judgeJittersUnitUpdate(channelInfo.adsConfig)) {
    channelInfo.adsConfig = updateAdsJittersUnit(channelInfo.adsConfig);
    save = true;
  }

  //judge extraction update - enableLogSweep, timeout, errorTolerance, maxSolution
  if (!isPreLayoutChannel && channelInfo.type === PCIE && channelInfo.content && (versionCompareSize(channelInfo.version, "0.0.15") || (channelInfo.content && !Object.keys(channelInfo.content.extraction).includes("enableLogSweep")))) {
    channelInfo.content.extraction = {
      ...channelInfo.content.extraction,
      enableLogSweep: true,
      errorTolerance: "0.005",
      maxSolution: "250"
    }
    save = true;
  }

  if (channelInfo.content && (versionCompareSize(channelInfo.version, "0.0.16") || judgeSelectCompExist(channelInfo.content.components))) {
    channelInfo = setSelectCompInComponents(channelInfo);
    save = true;
  }

  //set hdmi ami model
  if ([HDMI, GENERIC].includes(channelInfo.type) && channelInfo.content && !Object.keys(channelInfo.adsConfig || {}).length) {
    channelInfo = setDefaultAMIModel(channelInfo, { isPreLayoutChannel, netsList: _pcbInfo.netsList, serdesType: channelInfo.type });
    save = true;
  }

  //add default "IbisHasAMI" field
  if ([PCIE, HDMI, GENERIC].includes(channelInfo.type) && (versionCompareSize(channelInfo.version, "0.0.17") && judgeAMIFlagExist(channelInfo.adsConfig))) {
    channelInfo.adsConfig = updateSignalAMIFlags(channelInfo.adsConfig);
    save = true;
  }

  //if "Equalizer Adaptation" is turned off, update [TX_PRE_SHOOT, TX_DEEMPHASIS,LEQ_DC,LEQ_POLE,LEQ_DC2,LEQ_POLE2] value from array to string. 
  if (channelInfo.type === PCIE && judgeSeasimConfigEQValue(channelInfo.config)) {
    channelInfo.config = updateSeasimConfigEQ(channelInfo.config);
    save = true;
  }
  //Compatible with older versions of config, remove unnecessary fields according to "Equalizer Adaptation". Add required fields
  if (channelInfo.type === PCIE && versionCompareSize(channelInfo.version, "0.0.19")) {
    const returnInfo = updateSeasimEQConfig(channelInfo.config);
    channelInfo.config = returnInfo.config;
    save = returnInfo.save || save;
  }

  // Compatible with older versions of config, ....
  if (channelInfo.content && (versionCompareSize(channelInfo.version, "0.0.20") && !isPreLayoutChannel)) {
    channelInfo.content.extraction = updateExtractionInfo(channelInfo.content.extraction, design.type, channelInfo.type)
    save = true
  }

  // Add connectorModel/packageModel/tableModel, etc. from the old version to the modelList
  // Data when the usage in the package is BGA
  if (channelInfo.content && versionCompareSize(channelInfo.version, "0.0.21")) {
    channelInfo.content.components = updateModelInfoInConnPkgModel(channelInfo.content.components)
    save = true
  }

  // When RX is IBIS Model, modify the options for deleting CTLE Setting from ["Default", "Custom"] to ["Preset", "Custom"], as previously set to "Default" to "Custom"
  // When RX is a Termination Model, add jitter and EQ
  if (channelInfo.adsConfig && channelInfo.adsConfig.signals && (versionCompareSize(channelInfo.version, "0.0.22"))) {
    channelInfo.adsConfig.signals = updateAdsConfigDFEValue(channelInfo.adsConfig.signals)
    save = true
  }

  if (channelInfo.config && channelInfo.config.analysis && channelInfo.config.analysis.options && (versionCompareSize(channelInfo.version, "0.0.23"))) {
    channelInfo.config.analysis.options = updateAdsConfigDFEValue(channelInfo.config.analysis.options)
    save = true
  }

  // Fix the issue of missing data in hfss
  if (channelInfo.content && channelInfo.content.extraction && channelInfo.content.extraction.hfss && Object.keys(channelInfo.content.extraction.hfss).length && Object.keys(channelInfo.content.extraction.hfss).length < 11) {
    const new_hfss = new HFSSInfo();
    channelInfo.content.extraction.hfss = { ...new_hfss, ...channelInfo.content.extraction.hfss }
    save = true;
  }

  if (channelInfo.type === PCIE && judgeSeasimConfigGeneralValue(channelInfo.config)) {
    const info = updateSeasimConfigInfo(channelInfo.config);
    channelInfo.config = info.config;
    save = info.save || save;
  }

  if (channelInfo.content && (versionCompareSize(channelInfo.version, "0.0.24"))) {
    // check hspiceConfig -> signals -> ctleModels
    if (channelInfo && channelInfo.hspiceConfig && channelInfo.hspiceConfig.signals && Object.keys(channelInfo.hspiceConfig.signals).length > 0) {
      const newHspiceSignals = checkCtleModelPairs({
        hspiceSignals: channelInfo.hspiceConfig.signals,
        controller: channelInfo.hspiceConfig.controller,
        device: channelInfo.hspiceConfig.device,
        components: channelInfo.content.components,
        signals: channelInfo.content.signals
      });
      channelInfo.hspiceConfig.signals = newHspiceSignals;
    }

    // dieModel/pcbModel/connectorModel/pkg remove to modelList
    channelInfo.content.components = updateModelInfoInComponent(channelInfo.content.components)
    save = true;
  }


  if (!isPreLayoutChannel && channelInfo.content && channelInfo.content.additionalNets && !channelInfo.content.additionalNetsOption) {
    const { additionalNets, signals } = channelInfo.content;
    const additionalNetsOption = insertAdditionalNetsOption(channelInfo.designId, additionalNets, signals, channelInfo.type);
    channelInfo.content.additionalNetsOption = additionalNetsOption;
    save = true;
  }

  return { channelInfo, isReplace, save, findRefNetsStatus, updateGeneratePortsErrorsParams };
}

export {
  checkVersionUpdate
}